import { useCallback } from 'react';
import { InspoView } from '@/sections/inspo/views/inspo-view';
import { useNavigate, createFileRoute } from '@tanstack/react-router';
import { InspoPaywall } from '@/sections/inspo/components/inspo-paywall';
import { type InspoSearch, parseInspoSearch } from '@/sections/inspo/inspo-search';
import { InspoWgRequestProvider } from '@/sections/inspo/components/inspo-wg-request';

// /dashboard/o/:orgId/c/:clientId/inspo -- the platform email archive.
//
// Everything a person picks (tab, query, filters, the open email) lives in the
// query string, so a search can be shared and Back undoes the last change.

export const Route = createFileRoute('/_authed/dashboard/o/$orgId/c/$clientId/inspo/')({
  component: InspoPage,
  validateSearch: (search: Record<string, unknown>): InspoSearch => parseInspoSearch(search),
});

function InspoPage() {
  const { orgId, clientId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  const onSearchChange = useCallback(
    (patch: Partial<InspoSearch>, opts?: { replace?: boolean }) =>
      void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: opts?.replace }),
    [navigate]
  );

  const onReplaceSearch = useCallback(
    (next: InspoSearch) => void navigate({ search: next }),
    [navigate]
  );

  return (
    <InspoWgRequestProvider>
      <InspoPaywall>
        <InspoView
          search={search}
          onSearchChange={onSearchChange}
          onReplaceSearch={onReplaceSearch}
          onOpenBrand={(slug) =>
            void navigate({
              to: '/dashboard/o/$orgId/c/$clientId/inspo/brands/$slug',
              params: { orgId, clientId, slug },
            })
          }
          onOpenList={(listId) =>
            void navigate({
              to: '/dashboard/o/$orgId/c/$clientId/inspo/lists/$listId',
              params: { orgId, clientId, listId },
            })
          }
        />
      </InspoPaywall>
    </InspoWgRequestProvider>
  );
}
